// extracted by mini-css-extract-plugin
export var featuredMediaVideo = "FeaturedMediaVideo-module--featured-media-video--pCVM1";
export var fullHeight = "FeaturedMediaVideo-module--full-height--nb0-b";